<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card v-bind:title="isWorkflowExecution ? 'Pelaksanaan Tindakan #' + form.id : 'Edit Tindakan Medis'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              :route="'medical-actions/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from "@/component/medical-actions/FormEdit.vue";
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        patient_id: null,
        patient_name: "",
        patient_age: "",
        electro_laser: "",
        action_type: "",
        operator: "",
        responsible_doctor:"",
        anesteshia: "",
        anesthetist: null,
        notes: "",
        nurse_notes: "",
        date: "",
        medicines: "",
      },
      electro_laser: [],
      operator: [],
      action_type_id: [],
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('medical-actions/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/medical-actions/list')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  computed: {
    isWorkflowExecution() {
      return ['draft', 'in_progress', 'amended'].includes(this.form.workflow_status)
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Worklist Tindakan", route: "/medical-actions/requests" },
      { title: "Pelaksanaan" },
    ])
    // Get Data
    this.get()
  },

}

</script>
